var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle1Alternate2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle-1-alternate 2",
    clipPath: "url(#clip0_1196_7955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.32 4.29932C12.232 4.23441 12.132 4.18748 12.0258 4.16123C11.9196 4.13498 11.8092 4.12991 11.7011 4.14632C11.5929 4.16273 11.489 4.20029 11.3954 4.25685C11.3018 4.31342 11.2202 4.38788 11.1553 4.47599L7.20602 9.83598L4.69468 7.82665C4.52153 7.69401 4.3033 7.63448 4.08677 7.66083C3.87025 7.68718 3.67266 7.79731 3.53637 7.96761C3.40008 8.13791 3.33593 8.35482 3.35767 8.57186C3.37941 8.78889 3.48532 8.98877 3.65268 9.12865L6.84135 11.6793C6.92946 11.7482 7.03043 11.7989 7.13835 11.8284C7.24626 11.8578 7.35897 11.8655 7.46988 11.8509C7.5808 11.8363 7.68769 11.7998 7.78432 11.7434C7.88095 11.6871 7.96538 11.612 8.03268 11.5227L12.4994 5.46465C12.5641 5.37638 12.6109 5.2762 12.637 5.16985C12.663 5.06349 12.6678 4.95304 12.6512 4.84482C12.6345 4.73659 12.5967 4.63271 12.5399 4.53911C12.4831 4.44551 12.4083 4.36403 12.32 4.29932Z",
    fill: "#4CA202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87897 15.1541 3.84547 13.6543 2.34568C12.1545 0.845886 10.121 0.00229405 8 0ZM8 14.6667C6.68146 14.6667 5.39253 14.2757 4.2962 13.5431C3.19987 12.8106 2.34539 11.7694 1.84081 10.5512C1.33622 9.33305 1.2042 7.99261 1.46144 6.6994C1.71867 5.40619 2.35361 4.21831 3.28596 3.28596C4.21831 2.35361 5.4062 1.71867 6.6994 1.46143C7.99261 1.2042 9.33305 1.33622 10.5512 1.8408C11.7694 2.34539 12.8106 3.19987 13.5431 4.2962C14.2757 5.39253 14.6667 6.68146 14.6667 8C14.6647 9.76752 13.9617 11.4621 12.7119 12.7119C11.4621 13.9617 9.76752 14.6647 8 14.6667Z",
    fill: "#4CA202"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1196_7955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle1Alternate2);
export default __webpack_public_path__ + "static/media/check-circle-1-alternate 2.32037bde7bdad722627c839a6a728e81.svg";
export { ForwardRef as ReactComponent };